import request from "src/utils/Request";
import { redirect } from "react-router-dom";

const signOutLoader = async () => {
    await request('auth.logout');
    return redirect('/login')
};

export {signOutLoader};